import React, { Component } from "react";
import styled from "styled-components";
import api from "api";
import moment from "moment";

import { capitalize } from "helpers";
import WP from "WP";

import SnowmobileOrderInput from "./SnowmobileOrderInput";
import ContactForm from "./ContactForm";
import SuccessForm from "./SuccessForm";
import GridElement from "partials/GridElement";
import Html from "partials/Html";
import Button from "partials/Button";

import Media from "css/Media";

class SnowmobileRentalForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personalia: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        adress: "",
        postalCode: "",
        city: "",
      },
      price: [],
      submitted: false,
      disabled: false,
      validated: false,
      products: [],
      date: null,
      dateValid: true,
      days: 1,
      earlyPickup: false,
      clothing: false,
      /* insurance: false, */
      message: "",
    };
  }

  handleOnChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({ personalia: { ...this.state.personalia, [name]: value } });
  };

  handleTextAreaInputChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({ [name]: value });
  };

  setDropdownValue = (e, name) => {
    this.setState({ [name]: e });
  };

  handleCheck = (e) => {
    let target = e.target;
    this.setState({ [target.name]: !this.state[e.target.name] });
  };

  handleAddReservations = (id) => {
    const { products } = this.state;
    if (typeof id === "object" && id !== null) {
      this.setState({ products: [...products, id.id] });
    } else {
      this.setState({ products: [...products, id] });
    }
  };

  setDate = (dateObj) => {
    let string = capitalize(
      moment(new Date(dateObj)).format("dddd D. MMM. YYYY,")
    );
    this.setState({ date: dateObj, dateStr: string, dateValid: true });
  };

  validateFields = () => {
    const { personalia, products, date } = this.state;
    let contact = document.getElementById("contact_form");
    let snowmobile = document.getElementById("snowmobile_order_form");

    if (products.length) {
      if (date) {
        if (
          personalia.firstName.length > 0 &&
          personalia.lastName.length > 0 &&
          personalia.email.length > 0 &&
          personalia.phone.length > 0 &&
          personalia.adress.length > 0 &&
          personalia.postalCode.length > 0 &&
          personalia.city.length > 0
        ) {
          this.getProducts();
        } else {
          window.scrollTo({
            top: window.scrollY + contact.getBoundingClientRect().top,
            left: 0,
            behavior: "smooth",
          });
        }
      } else {
        this.setState({ dateValid: false });
        window.scrollTo({
          top: window.scrollY + snowmobile.getBoundingClientRect().top,
          left: 0,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: window.scrollY + snowmobile.getBoundingClientRect().top,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  getProducts = () => {
    api.rentalProductsFetcher
      .getByIds({ ids: this.state.products })
      .then((r) => this.getPrice(r.data));
  };

  getPrice = (products) => {
    let arr = [];

    products.map((product) => {
      let rental = {
        name: product.title.rendered,
        rentalPrice: [],
        /* insurance: 0, */
        earlyPickup: 0,
        total: [],
      };
      //set discouted price if product is rented for a week or longer
      if (this.state.days >= 7) {
        rental.rentalPrice.push(product.acf.price_week * this.state.days);
        rental.total.push(product.acf.price_week * this.state.days);
      } else {
        //set price based on weekday/weekend
        for (let i = 0; i < this.state.days; i++) {
          let date = new Date(this.state.date);
          let targetDay = new Date(date);
          targetDay.setDate(targetDay.getDate() + i);

          let day = targetDay.toString().split("").splice(0, 3).join("");
          rental.rentalPrice.push(this.isWeekend(day, product));
          rental.total.push(this.isWeekend(day, product));
        }
      }
      //add insurance cost if checked
      /* if(this.state.insurance && product.acf.product_insurance) {
                rental.insurance =  parseInt(product.acf.product_insurance[0].price)
                rental.total.push(parseInt(product.acf.product_insurance[0].price))
            } */
      //add early pickup fee if checked
      if (this.state.earlyPickup && product.acf.product_insurance) {
        rental.earlyPickup = parseInt(
          product.acf.product_insurance[0].early_pickup_price
        );
        rental.total.push(
          parseInt(product.acf.product_insurance[0].early_pickup_price)
        );
      }
      //add clothing fee if checked
      if (this.state.clothing && product.acf.product_insurance) {
        rental.clothing = parseInt(
          product.acf.product_insurance[0].clothing_price
        )
          ? parseInt(product.acf.product_insurance[0].clothing_price)
          : 0;
        rental.total.push(rental.clothing);
      }
      rental.rentalPrice = rental.rentalPrice.reduce((acc, num) => acc + num);
      rental.total = rental.total.reduce((acc, num) => acc + num);

      this.state.products
        .filter((x) => x == product.id)
        .forEach(() => {
          arr.push(rental);
        });
      return null;
    });
    this.setState({ rentals: arr }, () => this.handleSubmit());
  };

  isWeekend = (day, product) => {
    if (day == "Fri" || day == "Sat" || day == "Sun") {
      return parseInt(product.acf.price_weekends);
    } else {
      return parseInt(product.acf.price_weekdays);
    }
  };

  handleSubmit = () => {
    let form = document.getElementById("form");
    window.scrollTo({
      top: window.scrollY + form.getBoundingClientRect().top,
      left: 0,
      behavior: "smooth",
    });
    this.setState({ submitted: true });
    this.props.disableCards();

    api
      .sendSnowmobileRentalRequest({
        bookingEmail: this.props.booking_email,
        products: this.state.rentals,
        days: this.state.days,
        date: moment(new Date(this.state.date)).format("DD-MM-YYYY"),
        /* insurance: this.state.insurance, */
        earlyPickup: this.state.earlyPickup,
        clothing: this.state.clothing,
        price: this.state.rentals.map((rental) => rental.total + ", "),
        name:
          this.state.personalia.firstName +
          " " +
          this.state.personalia.lastName,
        email: this.state.personalia.email,
        phone: this.state.personalia.phone,
        adress: this.state.personalia.adress,
        postalCode: this.state.personalia.postalCode,
        city: this.state.personalia.city,
        message: this.state.message,
      })
      .then((resp) => {
        if (resp.data) {
          this.setState({ submitted: true });
          this.sendOrderConfirmationMail();
        }
      });
    this.setState({ disabled: true });
  };

  sendOrderConfirmationMail = () => {
    api.sendSnowmobileRentalOrderConfirmation({
      products: this.state.rentals,
      days: this.state.days,
      date: moment(new Date(this.state.date)).format("DD-MM-YYYY"),
      /* insurance: this.state.insurance, */
      earlyPickup: this.state.earlyPickup,
      clothing: this.state.clothing,
      price: this.state.rentals.map((rental) => rental.total + ", "),
      name:
        this.state.personalia.firstName + " " + this.state.personalia.lastName,
      email: this.state.personalia.email,
      phone: this.state.personalia.phone,
      adress: this.state.personalia.adress,
      postalCode: this.state.personalia.postalCode,
      city: this.state.personalia.city,
    });
  };

  render() {
    const { form_title, form_text_content, products, defaultValue } =
      this.props;
    const {
      days,
      earlyPickup,
      clothing,
      /* insurance, */
      personalia,
      dateStr,
      rentals,
      submitted,
      disabled,
      validEmailFormat,
      dateValid,
    } = this.state;

    return (
      <React.Fragment>
        {!submitted && (
          <FormGrid id='form'>
            <TitleGridElement
              id='snowmobile_order_form'
              colStart={{ default: 1, s: 3, m: 3 }}
              colEnd={{ default: 8, s: 14, m: 14 }}
              rowStart={1}
            >
              <h4>{form_title}</h4>
            </TitleGridElement>
            <GridElement
              colStart={{ default: 1, s: 3, m: 3 }}
              colEnd={{ default: 8, s: 14, m: 14 }}
              rowStart={2}
            >
              <SnowmobileOrderInput
                products={products}
                handleAddReservations={this.handleAddReservations}
                setDate={this.setDate}
                handleOnChange={this.handleOnChange}
                handleTextAreaInputChange={this.handleTextAreaInputChange}
                setDropdownValue={this.setDropdownValue}
                handleCheck={this.handleCheck}
                days={days}
                earlyPickup={earlyPickup}
                clothing={clothing}
                /* insurance={insurance} */
                defaultValue={defaultValue}
                dateValid={dateValid}
              />
            </GridElement>
            <DividerGridElement
              colStart={{ default: 1, s: 1, m: 1 }}
              colEnd={{ default: 8, s: 16, m: 16 }}
              rowStart={3}
            />
            <GridElement
              id='contact_form'
              colStart={{ default: 1, s: 1 }}
              colEnd={{ default: 8, s: 16 }}
              rowStart={4}
            >
              <ContactForm
                personalia={personalia}
                submitted={submitted}
                handleOnChange={this.handleOnChange}
                validateEmailFormat={this.validateEmailFormat}
                validEmailFormat={validEmailFormat}
              />
            </GridElement>
            {form_text_content && (
              <HtmlGridElement
                colStart={{ default: 1, s: 3 }}
                colEnd={{ default: 8, s: 14 }}
                rowStart={5}
              >
                <Html content>{form_text_content}</Html>
              </HtmlGridElement>
            )}
            <InputGridElement
              colStart={{ default: 1, s: 5, m: 11 }}
              colEnd={{ default: 4, s: 12, m: 14 }}
              colSpan
              rowStart={6}
              align='center'
            >
              <Button
                onClick={disabled ? null : () => this.validateFields()}
                tabIndex={1}
              >
                {submitted ? WP.trans.thanks : WP.trans.sendRegistration}
              </Button>
            </InputGridElement>
          </FormGrid>
        )}
        {submitted && (
          <SuccessForm
            date={dateStr}
            days={days}
            rentals={rentals}
            personalia={personalia}
          />
        )}
      </React.Fragment>
    );
  }
}

export default SnowmobileRentalForm;

const FormGrid = styled.div`
  /* display: -ms-grid; */
  display: grid;
  /* -ms-grid-columns: (1fr .359fr)[3] 1fr; */
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
  /* -ms-grid-rows: ${(props) => props.rows || "auto"}; */
  grid-template-rows: ${(props) => props.rows || "auto"};
  margin-bottom: ${(props) => props.theme.spacing.elementM};

  ${Media.greaterThan("s")`
        /* -ms-grid-columns: (1fr .67fr)[7] 1fr; */
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
        padding: ${(props) => props.theme.spacing.elementL} 0 ${(props) =>
    props.theme.spacing.blockM};
        margin-bottom: ${(props) => props.theme.spacing.blockL};
        border: 1px solid ${(props) => props.theme.colors.text};
    `}

  ${Media.greaterThan("m")`
        /* -ms-grid-columns: (1fr .435fr)[7] 1fr; */
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}
`;

const TitleGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementM};
    `}
`;

const HtmlGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.blockXS};
    `}
`;

const DividerGridElement = styled(GridElement)`
  width: 100%;
  padding-top: ${(props) => props.theme.spacing.elementL};
  margin-bottom: 0;

  ${Media.greaterThan("s")`
        border-bottom: 1px solid ${(props) => props.theme.colors.lines};
        padding-top: ${(props) => props.theme.spacing.blockS};
        margin-bottom: ${(props) => props.theme.spacing.blockS};
    `}
`;

const InputGridElement = styled(GridElement)`
  padding-bottom: ${(props) => props.theme.spacing.contentXL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${(props) => props.theme.spacing.elementM};
        }
    `}
`;
